// defaultPublic.tsx
import { INotificationMessage } from "@fl/shared/src/types/messages";
import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import AlterMessages from "../../components/alerts/indes";
import FilterComp from "../../components/filter";
import Loading from "../../components/loading";
import PrivateMenu from "../../components/menus/private";
import PublicMenu from "../../components/menus/public";
import Notifications from "../../components/notifications";
import { checkAuth } from "../../utils/authFuncs";
import packageJson from "../../../package.json";
const appVersion = packageJson.version;

interface IProps {
  title?: string;
  subtitle?: string;
  filterComp?: boolean;
  dataToFilter?: any[];
  setFilteredData?: React.Dispatch<React.SetStateAction<any[]>>;
  h3?: boolean;
  children: React.ReactNode;
  message?: INotificationMessage[];
  loading?: boolean;
}

const DefaultBasePage: React.FC<IProps> = ({
  title,
  filterComp,
  dataToFilter,
  setFilteredData,
  subtitle,
  h3,
  children,
  message,
  loading = false,
}) => {
  const [messages, setMessages] = useState<INotificationMessage[]>([]);

  useEffect(() => {
    if (message && message.length > 0) {
      const newMessages: INotificationMessage[] = [];
      message.map((item) => {
        if (!messages.find((msg) => msg.key === item.key))
          newMessages.push(item);
      });

      if (newMessages.length > 0) setMessages([...messages, ...newMessages]);
    }
  }, [message]);

  const year = new Date();
  const getMenu = () => {
    if (checkAuth()) {
      return <PrivateMenu />;
    } else {
      return <PublicMenu />;
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      <Notifications />

      {/* Cabeçalho */}
      {getMenu()}

      {/* Conteúdo Principal */}
      <main className="flex-grow-1">
        <Container fluid className="py-3 px-5">
          {loading ? (
            <Loading />
          ) : (
            <>
              <AlterMessages messages={messages} setMessages={setMessages} />

              {title && <h1>{title}</h1>}
              {filterComp && dataToFilter && setFilteredData && (
                <FilterComp data={dataToFilter} setData={setFilteredData} />
              )}
              {subtitle && (
                <div>
                  {h3 ? (
                    <h3 className="ms-2">
                      <i>{subtitle}</i>
                    </h3>
                  ) : (
                    <small>
                      <i>{subtitle}</i>
                    </small>
                  )}
                </div>
              )}

              <div className="p-2">{children}</div>
            </>
          )}
        </Container>
      </main>

      {/* Rodapé */}
      <footer className="footer bg-dark text-white text-center py-1 mt-auto">
        <div className="container">
          <p>
            <small>
              &copy; {year.getFullYear()} Sistemas Suporte FL. Todos os direitos
              reservados.
              <br />
              <small>
                Desenvolvido por <i>Gustavo Germiniani</i> — v{appVersion}
              </small>
            </small>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default DefaultBasePage;
